module.exports = __webpack_public_path__ + "static/media/gold_time.ad3ca868.svg";